import React from 'react';
import VesselKpi from './containers/VesselKpi';
import { useAppSelector } from '../../core/rootHooks';
import FleetKpi from './containers/FleetKpi';
import SummaryKpi from './containers/SummaryKpi';
import { EOutputType } from '../../shared/sharedEnums';
import { selectSelectionData } from '../search/searchSelectors';
import { kpiVesselListSelector, selectActivityCoverage, selectSectorActivityCoverage } from './kpiSelectors';
import { RootState } from '../../core/store';
import { TVesselInfo } from '../main-map/mapTypes';
import { IKpiVessel } from './kpiTypes';
import Logo from '../../shared/components/dashboard/Logo';
import ActivityLogoSrc from '../../assets/images/logos/logo_activity.svg';
import Coverage from '../../shared/components/dashboard/Coverage';
import { selectIsMsi } from '../../user-management/appSelectors';

const Kpis: React.FC = () => {
	const { outputType } = useAppSelector(selectSelectionData);
	const kpiVesselList = useAppSelector(kpiVesselListSelector);
	const { vesselsLastSignalData } = useAppSelector((state: RootState) => state.vesselsLastSignalSlice);
	const activityCoverage = useAppSelector(selectActivityCoverage);
	const sectorActivityCoverage = useAppSelector(selectSectorActivityCoverage);
	const isMsi = useAppSelector(selectIsMsi);

	// On Summary output, show the coverage of the currently active sector tab instead of the
	// overall selection coverage (which OutputMenu keeps using for the side menu item, untouched).
	const coverageData =
		outputType === EOutputType.Summary ? sectorActivityCoverage?.activityCoverageData : activityCoverage?.activityCoverageData;

	const filterKpisVesselsHaveSignal = (vesselSignals: TVesselInfo, vessels: IKpiVessel[]): IKpiVessel[] => {
		if (!vesselSignals || !vessels || vessels.length === 0) {
			return [];
		}
		// filter kpis vessels that have signals by imoNumber
		const vesselsWithSignals = vessels.filter((vessel) => {
			const vesselSignal = vesselSignals!.features.find((signal) => signal.properties?.imoNumber === vessel.imoNumber);
			return !!vesselSignal;
		});

		return vesselsWithSignals;
	};

	const vesselsWithSignals =
		((outputType === EOutputType.Vessel || outputType === EOutputType.Fleet) &&
			filterKpisVesselsHaveSignal(vesselsLastSignalData, kpiVesselList)) ||
		kpiVesselList;

	return (
		<>
			<Logo src={ActivityLogoSrc} />
			{((!vesselsWithSignals || vesselsWithSignals.length === 0) && <div />) || (
				<div className="flex-auto h-full w-full">
					{outputType === EOutputType.Vessel ? (
						<VesselKpi data={vesselsWithSignals[0]} />
					) : outputType === EOutputType.Fleet ? (
						<FleetKpi selectedVessels={vesselsWithSignals} />
					) : outputType === EOutputType.Summary ? (
						<SummaryKpi selectedVessels={vesselsWithSignals} />
					) : null}
				</div>
			)}

			{isMsi && coverageData && (
				<Coverage
					vesselsCount={coverageData.imoCount}
					calculatedVesselsCount={coverageData.calculatedImoCount}
					coveragePercentage={coverageData.coveragePercentage}
				/>
			)}
		</>
	);
};

export default Kpis;
